module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/create-order/create-order.component.css
// module id = ./src/app/create-order/create-order.component.css
// module chunks = main